<template>
  <div>
    <v-row v-if="!loading" :class="mt">
      <v-col
        v-for="(item, index) in items"
        :key="index"
        cols="12"
        sm="6"
        lg="4"
        xl="3"
      >
        <CaseCard
          :title="item[titleKey]"
          :color="getColor(item)"
          :chips="chips(item)"
          :under-left="item[underLeftKey]"
          :under-right="item[underRightKey]"
          :deadline="item[deadlineKey]"
          :removeBottom="removeBottom"
          :removeArrowIcon="removeArrowIcon"
          @click="clickCard(item)"
        >
          <template v-slot:title>
            <slot name="title" :item="item"></slot>
          </template>

          <template v-slot:topRight>
            <slot name="topRight" :item="item"></slot>
          </template>

          <template v-slot:chips>
            <slot name="chips" :item="item"></slot>
          </template>
          <template v-slot:deadline>
            <slot name="deadline" :item="item"></slot>
          </template>
          <template v-slot:underRight>
            <slot name="underRight" :item="item"></slot>
          </template>
          <template v-slot:underLeft>
            <slot name="underLeft" :item="item"></slot>
          </template>
        </CaseCard>
      </v-col>
    </v-row>
    <v-row v-if="loading" class="mt-3">
      <v-col v-for="index in 4" :key="index" sm="6" lg="4" xl="3">
        <CaseCard :loading="true" />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";

interface listObject {
  title?: string;
  status?: string;
  color?: string;
  sameie?: boolean;
}

export default Vue.extend({
  name: "MeasureCards",
  props: {
    value: {
      type: Array as () => Array<listObject>,
    },
    loading: {
      type: Boolean,
    },
    titleKey: {
      type: String,
      default: "title",
    },
    deadlineKey: {
      type: String,
      default: "deadline",
    },
    underRightKey: {
      type: String,
      default: "responsible",
    },
    underLeftKey: {
      type: String,
      default: "project",
    },
    removeBottom: {
      type: Boolean,
      default: false,
    },
    removeBottomLoading: {
      type: Boolean,
      default: false,
    },
    removeArrowIcon: {
      type: Boolean,
      default: false,
    },
    mt: {
      type: String,
      default: "mt-3",
    },
  },
  mounted() {
    this.scroll();
  },
  methods: {
    scroll() {
      if (!this.removeBottomLoading) {
        window.onscroll = () => {
          //scrollFromBottomLoade start loading before user hits bottom.
          var bottomOfWindow =
            document.documentElement.scrollHeight -
              document.documentElement.scrollTop ===
            document.documentElement.clientHeight;

          if (bottomOfWindow) {
            this.$emit("fetchData", true);
          }
        };
      }
    },
    clickCard(item) {
      this.$emit("click", item);
    },
    title(item) {
      return (item.id ? item.id : "") + (item.title ? ` - ${item.title}` : "");
    },
    getColor(item) {
      if (item?.color) {
        return item.color;
      } else if (item) {
        this.$emit("setColor", item);
      }
    },
    chips(item) {
      var data = [
        {
          title: item.aberrationActionStatus,
          color: this.getColor(item.aberrationActionStatus),
        },
      ];
      if (item.aberrationSeverity) {
        data.push({
          title: item.aberrationSeverity,
          color: "",
        });
      }

      return data;
    },
  },
  computed: {
    items: {
      get(): Array<listObject> {
        return this.value;
      },
    },
  },
  components: {
    CaseCard,
  },
});
</script>
